module.exports = __webpack_public_path__ + "static/media/socialf.c8656d65.svg";